const propertyModel = [
  '$http',
  'urlConstants',
  function ($http, urlConstants) {
    return {
      apiPath: urlConstants.api.v1.path + 'property_page_data_application',
      propertyApi: new PropertyAPI(),

      claim: function (propertyId, userId) {
        return this.propertyApi.claim(propertyId, userId)
      },
      sendEmail: function (application, propertyId) {
        return $http.post(this.apiPath, {
          application: application,
          property_id: propertyId,
        })
      },
    }
  },
]
export default propertyModel
